import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { CheckSquare, PersonAdd, Square } from 'react-bootstrap-icons'
import { useNavigate, useParams } from 'react-router-dom'
import useDebounce from '../../../../components/Hooks/useDebounce'
import Access from '../../../../libs/api/services/Access'
import Patient from '../../../../libs/api/services/Patient'
import User from '../../../../libs/api/services/User'
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'

export default function PatientProfileOtherRelation({ PatientId }) {
    const { id } = useParams()
    const [loading, setLoading] = useState(true)
    const [relate, setRelate] = useState([])
    const { showError, createModal } = useContext(CommonFunctionsContext)
    const load = async () => {
        setRelate(await Patient.ListPatientRelationShips(id ? id : PatientId).catch(showError))
        setLoading(false)
    }

    useEffect(() => {
        load()
    }, [])

    const _handleAssign = () => createModal(<NewUserDetails onClosed={load} patientID={id ? id : PatientId} />, "Assign Relationship", <PersonAdd />)

    return (loading ?
        <div className='d-flex flex-grow-1 flex-column align-items-center justify-content-center'>
            <FontAwesomeIcon icon={faSpinner} size={'4x'} spin />
            <b className='p-3'>Loading Relationships</b>
        </div> :
        <>
            <div className='flex-shrink-1'>
                <h2 className='text-center m-2'>Patient's relationships</h2>
            </div>
            <div className='flex-grow-1' style={{ overflow: 'auto' }}>
                {relate && relate.map((relation, idx) =>
                    <RelateLineItem relation={relation} />)}
            </div>
            <div className='text-center m-2 flex-shrink-1'>
                <button onClick={() => _handleAssign()} className='btn bg-primary-container'>Assign relationship</button>
            </div>
        </>
    )
}
const RelateLineItem = ({ relation, onRemove }) => {
    const [show, setShow] = useState(false)
    return (
        <>
            <div className='d-flex m-2 row'>
                <div className='col-12 col-xl-2'><b>{relation.relationShip.role}</b></div>
                <div className='col-12 col-xl-2'>{relation.withWho.firstName}</div>
                <div className='col-12 col-xl-2'>{relation.withWho.lastName}</div>
                <div className='col-12 col-xl-4'>{relation.withWho.emailAddress}</div>
                <div className='col-12 col-xl-2'>{relation.withWho.mobileNumber}</div>
            </div>
        </>
    )
}

const NewUserDetails = ({ close, patientID, onClosed }) => {
    const { showError } = useContext(CommonFunctionsContext)
    const nav = useNavigate()
    const [apiRoles, setAPIRoles] = useState()
    const [role, setRole] = useState()
    const [profile, setProfile] = useState({
        idNumber: '',
        firstName: '',
        lastName: '',
        mobileNumber: '',
        emailAddress: '',
    })
    const [status, setStatus] = useState()
    // const [idNumber, setIDNumber] = useState()
    const debouncedInputValue = useDebounce(profile.idNumber, 300);
    const IDNumberRef = useRef()
    const TeamRef = useRef()

    useEffect(() => {
        if (debouncedInputValue && debouncedInputValue.length > 12) {
            setStatus('Searching for user profile')
            User.LookupByIDNumber(debouncedInputValue)
                .then(res => {
                    setTimeout(() => { setStatus() }, 1000)
                    if (res)
                        setProfile({ ...res })
                }).catch(e => setTimeout(() => { setStatus(); }, 1000))

        } else setStatus()
    }, [debouncedInputValue])

    const _handleSubmit = async (e) => {
        e.preventDefault()
        var _profile = { ...profile, ...await User.add(profile).catch(showError) }
        if (!profile.id)
            _profile = { ...profile, ...await User.add(profile).catch(showError) }
        await Patient.AssignPatientRelationShip(patientID, {
            RelationShip: _profile.role,
            WithWho: { ..._profile, role: undefined }
        }).catch(showError)
        close(() => onClosed())
    }

    useEffect(() => { if (IDNumberRef.current) IDNumberRef.current.focus() }, [IDNumberRef])
    useEffect(() => {
        const load = async () => setAPIRoles(await Access.ListFacilityRoles('PatientRelationship').catch(showError))
        load()
    }, [])

    return (<form onSubmit={_handleSubmit} className='d-flex flex-column flex-grow-1' style={{ maxHeight: '100%' }}>

        <div className='flex-grow-1 m-3' style={{ overflow: 'auto' }}>
            <h2>Basic Information</h2>
            <div>
                <label>ID Number</label>
                <input ref={IDNumberRef} value={profile.idNumber}
                    onChange={e => setProfile({ ...profile, idNumber: e.target.value })}
                    className='form-control' placeholder='ID Number' autofocus />
            </div>
            {status && <div className='text-center'>
                <><FontAwesomeIcon icon={faSpinner} spin /> {status}</>
            </div>}
            {
                profile.idNumber && profile.idNumber.length > 12 &&
                <>
                    <div className='d-flex'>
                        <div className='w-50 pe-2'>
                            <label>First Name</label>
                            <input
                                value={profile.firstName}
                                onChange={e => setProfile({ ...profile, firstName: e.target.value })}
                                className='form-control' placeholder='First Name' />
                        </div>
                        <div className='w-50 ps-2'>
                            <label>Last Names</label>
                            <input
                                value={profile.lastName}
                                onChange={e => setProfile({ ...profile, lastName: e.target.value })}
                                className='form-control' placeholder='Last Names' />
                        </div>
                    </div>
                    <div className='d-flex'>
                        <div className='w-50 pe-2'>
                            <label>Mobile</label>
                            <input
                                type='tel'
                                required
                                value={profile.mobileNumber}
                                onChange={e => setProfile({ ...profile, mobileNumber: e.target.value })}
                                className='form-control' placeholder='Mobile' />
                        </div>
                        <div className='w-50 ps-2'>
                            <label>Email</label>
                            <input
                                type='Email'
                                required
                                value={profile.emailAddress}
                                onChange={e => setProfile({ ...profile, emailAddress: e.target.value })}
                                className='form-control' placeholder='Email' />
                        </div>
                    </div>
                    <h2>Relationship</h2>
                    <div className='w-100' style={{ cursor: 'pointer' }}>
                        <div className='d-flex flex-column align-items-start'>
                            {apiRoles && apiRoles.map(aRole =>
                                <button
                                    type='button'
                                    className='btn'
                                    onClick={_ => setProfile({ ...profile, role: aRole })}
                                    id={aRole.id}>
                                    {profile && profile.role && profile.role.id === aRole.id ? <CheckSquare /> : <Square />} {aRole.role}</button>
                            )}
                        </div>

                    </div>
                </>
            }
        </div>
        <div className='text-center flex-shrink-1'><button type='submit' className='btn bg-primary-container'>Next</button></div>
    </form>
    )
}